import { render, staticRenderFns } from "./UciBook.vue?vue&type=template&id=99bf24fc"
import script from "./UciBook.vue?vue&type=script&lang=js"
export * from "./UciBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports